module.exports = __webpack_public_path__ + "static/media/cypress.a814d99b.png";